import React from "react";
import App from "./App";
import ProductThemeProvider from "@civicplus/preamble-ui/lib/ProductThemeProvider";
import ReactDOM from "react-dom/client";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";

// One catch-all route: App keeps its nested <Routes>, and the data router enables useBlocker
const router = createBrowserRouter([{ path: "*", element: <App /> }]);

const container = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(container!);

root.render(
    <React.StrictMode>
        <ProductThemeProvider prefix="cp-notificationswrapper" product="notifications">
            <RouterProvider router={router} />
        </ProductThemeProvider>
    </React.StrictMode>
);
